// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__Basts","label":"SetPasswdForm_label__2g4X7"};